import { axiosClient } from '../utils/axiosClient.js';
import * as Paths from '@/components/common/paths';
import { handleServerError } from '@/components/common/errorUtils';
import i18n from '@/i18n';

// 翻訳キーから値を取得するヘルパー関数
const t = (key) => {
    try {
        return i18n.global.t(key);
    } catch (e) {
        return '';
    }
};

const actions = {
    async update({ dispatch }, updateData) {
        try {
            const response = await axiosClient.post(`${Paths.SETTING_URL}${updateData.operator_id}`, updateData);
            const data = response.data;

            if (data.type === 0) {
                dispatch('dataManagement/setOperatorInfo', updateData, { root: true });
                return { success: true };
            } else {
                return { success: false, error: 'Unexpected data type' };
            }
        } catch (error) {
            console.error(handleServerError(error), error);
            return { success: false, error: t('errors.settings_update_failed') };
        }
    },
};

export default {
    namespaced: true,
    actions,
};
